import styled from "styled-components";

export const SelectDrugButtons = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  row-gap: 5px;
  column-gap: 5px;
  justify-items: stretch;
  justify-content: center;
  padding: 0 3px;
`;
